import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasSpinnerComponent } from './gas-spinner.component';

const COMPONENTS = [
  GasSpinnerComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasSpinnerModule { }
